import { supabase } from "../supabaseClient";

/* ================= PROJECTS ================= */
export const fetchProjects = () => {
  return supabase
    .from("Projects")
    .select("projectId, projectName")
    .eq("isVJ", true);
};










/* ================= PROJECT PARKING TYPES ================= */
export const fetchProjectParkingTypesFromInventory = async (projectId) => {
  try {
    // STEP 1: Get parkingTypeId from parkingInventory
    const { data: inventoryData, error: inventoryError } = await supabase
      .from("ParkingInventory")
      .select("parkingTypeId")
      .eq("projectId", projectId)
      .not("parkingTypeId", "is", null);

    if (inventoryError || !inventoryData?.length) {
      console.log("No parking inventory found for project:", projectId);
      return { data: [], error: null };
    }

    // STEP 2: Get unique parkingTypeIds
    const uniqueParkingTypeIds = [...new Set(inventoryData.map(item => item.parkingTypeId))];

    // STEP 3: Get names from ParkingTypes in SINGLE QUERY
    const { data: parkingTypes, error: ptError } = await supabase
      .from("ParkingTypes")
      .select("parkingTypeId, parkingType")
      .in("parkingTypeId", uniqueParkingTypeIds);

    return { data: parkingTypes || [], error: ptError };
  } catch (error) {
    console.error("fetchProjectParkingTypesFromInventory error:", error);
    return { data: [], error };
  }
};

/* ================= PROJECT INVENTORY RELATIONS ================= */

// Fetch UNIQUE wingIds for project
export const fetchWingsFromProjectInventory = async (projectId) => {
  const { data, error } = await supabase
    .from("ProjectInventoryRelations")
    .select("wingId")
    .eq("projectId", projectId)
    .not("wingId", "is", null);

  if (error || !data?.length) return { data: [], error };

  const wingIds = [...new Set(data.map(d => d.wingId))];

  const { data: wings, error: wingError } = await supabase
    .from("Wings")
    .select("wingId, wingName")
    .in("wingId", wingIds);

  return { data: wings || [], error: wingError };
};

// Fetch UNIQUE unit types for project + wing
export const fetchUnitTypesFromProjectInventory = async (projectId, wingId) => {
  // STEP 1: Get unitIds from ProjectInventoryRelations
  const { data: relationData, error: relationError } = await supabase
    .from("ProjectInventoryRelations")
    .select("unitId")
    .eq("projectId", projectId)
    .eq("wingId", wingId)
    .not("unitId", "is", null);

  if (relationError || !relationData?.length) {
    return { data: [], error: relationError };
  }

  const unitIds = [...new Set(relationData.map(r => r.unitId))];

  // STEP 2: Fetch Inventory using Inventory.unitId (CORRECT)
  const { data: inventoryData, error: inventoryError } = await supabase
    .from("Inventory")
    .select("inventoryTypeId, displayUnitType")
    .in("unitId", unitIds);

  if (inventoryError || !inventoryData?.length) {
    return { data: [], error: inventoryError };
  }

  // STEP 3: Deduplicate by inventoryTypeId
  const uniqueUnitTypes = Array.from(
    new Map(
      inventoryData.map(item => [
        item.inventoryTypeId,
        {
          inventoryTypeId: item.inventoryTypeId,
          displayUnitType: item.displayUnitType,
        }
      ])
    ).values()
  );

  return { data: uniqueUnitTypes, error: null };
};

/* ================= PROJECT + WING PARKING TYPES ================= */
export const fetchProjectWingParkingTypesFromInventory = async (projectId, wingId) => {
  try {
    // STEP 1: Get parkingTypeIds from ParkingInventory
    const { data: inventoryData, error: inventoryError } = await supabase
      .from("ParkingInventory")
      .select("parkingTypeId")
      .eq("projectId", projectId)
      .eq("wingId", wingId)
      .not("parkingTypeId", "is", null);

    if (inventoryError || !inventoryData?.length) {
      return { data: [], error: null };
    }

    // STEP 2: Unique parkingTypeIds
    const uniqueIds = [...new Set(inventoryData.map(i => i.parkingTypeId))];

    // STEP 3: Fetch names
    const { data: parkingTypes, error } = await supabase
      .from("ParkingTypes")
      .select("parkingTypeId, parkingType")
      .in("parkingTypeId", uniqueIds);

    return { data: parkingTypes || [], error };
  } catch (error) {
    console.error("fetchProjectWingParkingTypesFromInventory error:", error);
    return { data: [], error };
  }
};


export const saveParkingConfig = async (configs) => {
    if (!Array.isArray(configs) || configs.length === 0) {
        return { data: null, error: new Error('No configurations provided') };
    }

    try {
        console.log('🚀 Inserting configs (PURE INSERT):', configs);

        // ✅ PURE INSERT - Fails on duplicates (no upsert overwrites)
        // Use separate edit flow for updates
        const { data, error } = await supabase
            .from('UnitType_ParkingType_Config')
            .insert(configs)  // ✅ INSERT ONLY - errors if exists
            .select();

        if (error) {
            console.error('❌ Supabase insert error:', error);
            return { data: null, error };
        }

        console.log('✅ INSERT successful:', data);
        return { data, error: null };
    } catch (error) {
        console.error('❌ Unexpected insert error:', error);
        return { data: null, error };
    }
};

// Services/ParkingConfiguration.js
export const fetchParkingConfig = async (projectId) => {
    try {
        const { data, error } = await supabase
            .from('UnitType_ParkingType_Config')
            .select(`
                UnitType_ParkingType_Config_id,
                ProjectId,
                WingId,
                UnitTypeId,
                ParkingTypeId,
                isUpgrade,
                IsUpgradeEligible
            `)
            .eq('ProjectId', projectId)
            .order('WingId', { ascending: true });

        if (error) {
            console.error('❌ Fetch parking config error:', error);
            return { data: null, error };
        }

        console.log('✅ Fetched parking configs:', data);
        return { data, error: null };
    } catch (error) {
        console.error('❌ Unexpected fetch error:', error);
        return { data: null, error };
    }
};


export const deleteParkingConfig = async (projectId, wingId, unitTypeId, parkingTypeId) => {
  console.log('🗑️ DELETE QUERY:', { projectId, wingId, unitTypeId, parkingTypeId });
  try {
    const { data, error, count } = await supabase
      .from('UnitType_ParkingType_Config')
      .delete()
      .eq('ProjectId', projectId)
      .eq('WingId', wingId)
      .eq('UnitTypeId', unitTypeId)
      .eq('ParkingTypeId', parkingTypeId)
      .select();  // Returns deleted rows

    console.log('🗑️ SUPABASE DELETE RESULT:', { data, error, count: data?.length });

    if (error) {
      console.error('❌ Delete error:', error);
      return { data: null, error };
    }
    if (!data || data.length === 0) {
      console.warn('⚠️ No rows matched delete criteria');
      return { data: [], error: new Error('No matching configuration found') };
    }
    return { data, error: null };
  } catch (error) {
    console.error('❌ Unexpected delete error:', error);
    return { data: null, error };
  }
};





// ✅ NEW: UPDATE service for EDIT button
export const updateParkingConfig = async (config) => {
  if (!config || !config.ProjectId) {
    return { data: null, error: new Error('Invalid config for update') };
  }

  try {
    console.log('✏️ UPDATING config:', config);
    
    const { data, error } = await supabase
      .from('UnitType_ParkingType_Config')
      .update({
        isUpgrade: config.isUpgrade,
        IsUpgradeEligible: config.IsUpgradeEligible,
        // Don't update IDs - just flags
      })
      .eq('ProjectId', config.ProjectId)
      .eq('WingId', config.WingId)
      .eq('UnitTypeId', config.UnitTypeId)
      .eq('ParkingTypeId', config.ParkingTypeId)
      .select();

    if (error) {
      console.error('❌ Update error:', error);
      return { data: null, error };
    }

    console.log('✅ UPDATE successful:', data);
    return { data, error: null };
  } catch (error) {
    console.error('❌ Update unexpected error:', error);
    return { data: null, error };
  }
};


export const updateProjectParkingToggle = async (projectId, allowParkingSelection) => {
  try {
    const { data, error } = await supabase
      .from("Projects")
      .update({
        allowParkingSelection, // true / false
        last_updated_at: Date.now(),
      })
      .eq("projectId", projectId)
      .select("allowParkingSelection");

    if (error) {
      console.error("❌ Update allowParkingSelection failed:", error);
      return { data: null, error };
    }

    return { data, error: null };
  } catch (err) {
    console.error("❌ Unexpected error:", err);
    return { data: null, error: err };
  }
};

export const fetchProjectParkingToggle = async (projectId) => {
  const { data, error } = await supabase
    .from("Projects")
    .select("allowParkingSelection")
    .eq("projectId", projectId)
    .single();

  return { data, error };
};


